<script lang="ts">
import { defineComponent } from "vue";
import DbButton from "@/components/DB-Components/DbButton.vue";
import { i18n } from "@/i18n/i18n";
export default defineComponent({
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    modalType: {
      type: String as () => "submitCancel" | "accept",
      default: () => "submitCancel",
      required: false,
    },
    submitText: {
      type: String,
      default: i18n.global.t("order.save"),
      required: false,
    },
    cancelText: {
      type: String,
      default: i18n.global.t("order.cancel"),
      required: false,
    },
  },
  emits: ["hideModal", "submit"],
  setup(props, context) {
    const close = () => {
      context.emit("hideModal");
    };
    const submit = () => {
      context.emit("submit");
    };
    return {
      close,
      submit,
    };
  },
  components: { DbButton },
});
</script>
<template>
  <div
    id="app-modal"
    :class="visible ? 'flex' : 'hidden'"
    tabindex="-1"
    class="fixed top-0 left-0 right-0 bottom-0 px-5 flex items-center justify-center z-50"
  >
    <div class="relative w-full max-w-xl max-h-full z-50">
      <!-- Modal content -->
      <div class="relative bg-white rounded-lg shadow">
        <slot></slot>
        <div class="py-3 flex flex-wrap justify-center gap-1">
          <DbButton
            @on-click="close"
            class="hydrated button-gap"
            :variant="
              modalType === 'submitCancel' ? 'secondary-solid' : 'primary'
            "
            >{{ $t(`${cancelText}`) }}</DbButton
          >
          <DbButton
            v-if="modalType === 'submitCancel'"
            @on-click="submit"
            class="hydrated px-4"
            >{{ $t(`${submitText}`) }}</DbButton
          >
        </div>
      </div>
    </div>
    <div
      modal-backdrop=""
      :class="visible ? 'flex' : 'hidden'"
      class="bg-gray-900 bg-opacity-50 fixed inset-0 z-40"
    ></div>
  </div>
</template>
